import { IUserDetail } from "@interfaces/Core/Users/userDetail";
import useApiCall from "@hooks/Shared/useApiCall";

const useGetUser = (uuid: string) =>
  useApiCall<IUserDetail>({
    url: `/users/${uuid}`,
  });

export default useGetUser;
